import { JobExecution } from '@lct-jobs/core';

export enum MassOperationType {
  MASS_JOB = 'massJob',
  MASS_QUERY = 'massQuery',
}

/**
 * Mass jobs and mass queries are both executed by the MassJobExecutor job, so jobId, jobName and
 * tenantType are identical for both. Only the stored input distinguishes them.
 */
interface MassOperationInput {
  massJob?: { jobId?: string };
  queryInfo?: { queryName?: string };
}

/**
 * lct-jobs' region list (ListRegionExecutions) leaves out jobInput and returns the same two values
 * as massJobId and massQueryName, so those are read when the input is not there.
 */
type ListedExecution = JobExecution & { massJobId?: string; massQueryName?: string };

const massOperationInput = (execution?: JobExecution) =>
  execution?.jobInput as MassOperationInput | undefined;

const massJobId = (execution?: JobExecution) =>
  massOperationInput(execution)?.massJob?.jobId ?? (execution as ListedExecution)?.massJobId;

const massQueryName = (execution?: JobExecution) =>
  massOperationInput(execution)?.queryInfo?.queryName ??
  (execution as ListedExecution)?.massQueryName;

export const getMassOperationType = (execution?: JobExecution): MassOperationType | undefined => {
  const input = massOperationInput(execution);
  if (input?.massJob || massJobId(execution)) {
    return MassOperationType.MASS_JOB;
  }
  if (input?.queryInfo || massQueryName(execution)) {
    return MassOperationType.MASS_QUERY;
  }
  return undefined;
};

/** The child job id for a mass job, or the query name for a mass query. */
export const getMassOperationName = (execution?: JobExecution): string | undefined =>
  massJobId(execution) ?? massQueryName(execution);
